import axios from 'axios';
import { CHAT_DOMAIN } from '../constants';
import { generateUUID } from '../utils/utils';
import { UserRoles } from '../interfaces/user';

// eslint-disable-next-line no-restricted-globals
const baseURL = location.hostname === 'localhost' ? '/api/v4' : CHAT_DOMAIN;

export const getMyAuthToken = () => {
  return axios.get('/api/mattermost/user_token');
};

export const getChats = (page: number, per_page: number, archived?: boolean) => {
  return axios.get(`/api/mattermost/user_channels`, {
    params: {
      archived: archived || undefined,
      page,
      per_page,
    },
  });
};

export const getChat = (companyId: string | number) => {
  return axios.post(`/api/mattermost/group_channel?company_id=${companyId}`);
};

export const getPostsForChannel = (channelId: string, page: number, before?: string) => {
  let url = `/channels/${channelId}/posts?page=${page}&per_page=1000`;
  if (before) {
    url += `&before=${before}`;
  }
  return axios.get(url, { baseURL });
};

export const createPost = (
  channelId: string,
  message: string,
  props?: {},
  fileIds?: string[]
) => {
  const data = {
    channel_id: channelId,
    message,
    props: props || {},
    file_ids: fileIds,
  };
  return axios.post('/posts', data, { baseURL });
};

export const getMe = () => {
  return axios.get('/users/me', { baseURL });
};

export const uploadFile = (channelId: string, file: File, name: string) => {
  const formData = new FormData();
  formData.append('channel_id', channelId);
  formData.append('client_ids', generateUUID());
  formData.append('files', file);
  const url = `/files?channel_id=${channelId}&fileName=${name}`;
  const options = {
    headers: { 'Content-Type': 'multipart/form-data' },
    baseURL,
  };
  return axios.post(url, formData, options);
};

export const getUploadedFile = (id: string, isPreview?: boolean) => {
  return axios.get(`/files/${id}${isPreview ? '/preview' : ''}`, {
    baseURL,
    responseType: 'blob',
  });
};

export const getMessagesGPT = (user_id?: number | string) => {
  return axios.get('/api/gpt/messages', { params: { user_id } });
};

export const postMessageGPT = (data: FormData) => {
  return axios.post('/api/gpt/message', data);
};

export const getSettingGPT = (
  type: 'main_promt' | 'promt' | 'dialog_opening' | 'avatar' | 'model' | 'model_2' | 'generation_promt' | 'improve_promt' | 'translate_promt' | 'text_translation_promt' | 'product_description_promt' | 'text_improvement_promt',
  locale?: string,
  user_role?: UserRoles
) =>
  axios.get('/api/gpt_settings', {
    params: {
      type,
      locale,
      user_role,
    },
  });

export const editSettingGPT = (data: FormData) => axios.post('/api/gpt_settings', data);

export const getChatsGPT = (params: {
  user_id?: number;
  role?: string;
  phone?: string;
  email?: string;
  date_from?: string;
  date_to?: string;
  page?: number;
  per_page?: number;
}) => axios.get('/api/gpt/messages_stat', { params });

export const deleteGPTChat = (user_id?: number) =>
  axios.delete('/api/gpt/chat', { params: { user_id } });

export const getStartMessageGPT = (locale: string) => {
  return axios.get('/api/gpt_settings', { params: { type: 'dialog_opening', locale } });
};

export const getGPTModels = () => axios.get(`/api/gpt_models`);

export const generatedPhotos = (
  product_id: string,
  photo_ids: string,
) => {
  return axios.post(
    '/api/gpt/photo_description',
    {},
    {
      params: { product_id, photo_ids },
    }
  );
};

export const generatedAiText = (
  text: string,
  product_id: string,
) => {
  return axios.post(
    '/api/gpt/text_improvement',
    {},
    {
      params: { text, product_id },
    }
  );
};

export const generatedAiTranslation = (
  text: string,
  product_id: string,
) => {
  return axios.post(
    '/api/gpt/text_translation',
    {},
    {
      params: { text, product_id },
    }
  );
};

